const CONFIGURED_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const BACKEND_URL = process.env.NODE_ENV === "production" ? "" : CONFIGURED_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const request = async (path, token, options = {}) => {
  const response = await fetch(`${API}${path}`, {
    credentials: "include",
    headers: {
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
    ...options,
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    const error = new Error(body.detail || `Request failed: ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return response.json();
};

export const getMarketIntelligenceStatus = async (token) =>
  request("/market-intelligence/status", token);

export const getMarketIntelligenceSummary = async (token, symbol) =>
  request(`/market-intelligence/summary${symbol ? `?symbol=${encodeURIComponent(symbol)}` : ""}`, token);

export const getMarketIntelligenceHistory = async (token, { symbol, limit = 20 } = {}) => {
  const params = new URLSearchParams();
  if (symbol) params.set("symbol", symbol);
  params.set("limit", String(limit));
  return request(`/market-intelligence/history?${params.toString()}`, token);
};


export const getMarketLearningSummary = async (token, symbol) =>
  request(`/market-intelligence/learning-summary${symbol ? `?symbol=${encodeURIComponent(symbol)}` : ""}`, token);
